<template>
  <div class="home">
    <!-- 热力图开始 -->
    <HeatMap />
    <!-- 热力图结束 -->

    <div class="home__left">
      <BatteryStatusList :options="batteryStatusOptions" />

      <Card
        title="实时报警数据"
        style="flex: 5"
      >
        <Table />
      </Card>

      <Card
        title="电池种类"
        style="flex: 3"
      >
        <Chart :option="batteryTypeOption" />
      </Card>
    </div>
    
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeatMap from "./HeatMap.vue";
import Chart from "@/components/Chart/index.vue";
import BatteryStatusList from "./BatteryStatusList.vue";
import Table from "./Table.vue";
import Card from "./Card.vue";

export default {
  components: {
    HeatMap,
    BatteryStatusList,
    Table,
    Card,
    Chart
  },

  data() {
    return {
      myWidth: null,
      myHeight: null,
      faultOption: {},
      batteryTypeOption: {},
      realStausOption: {},
      onlineRateOption: {},
      countOptions: [
        {
          label: "设备总数",
          startVal: 0,
          endVal: 0
        },
        { label: "当日新增数量", startVal: 0, endVal: 0 }
      ],
      batteryStatusOptions: [
        {
          label: "设备总数",
          startVal: 0,
          endVal: 0,
          icon: require("@/assets/img/home/total.png")
        },
        {
          label: "在线设备",
          startVal: 0,
          endVal: 0,
          icon: require("@/assets/img/home/online.png")
        },
        {
          label: "当日新增",
          startVal: 0,
          endVal: 0,
          icon: require("@/assets/img/home/add.png")
        },
        {
          label: "短路次数",
          startVal: 0,
          endVal: 0,
          icon: require("@/assets/img/home/ShortCircuit.png")
        },
        {
          label: "当日充电",
          startVal: 0,
          endVal: 0,
          icon: require("@/assets/img/home/Charging.png")
        },
        {
          label: "当日放电",
          startVal: 0,
          endVal: 0,
          icon: require("@/assets/img/home/Discharge.png")
        },
      ],
      batteryAlarmOptions: [
        {
          label: "过充数量",
          startVal: 0,
          endVal: 0,
          icon: "icon-chongdianguoliang"
        },
        {
          label: "过放数量",
          startVal: 0,
          endVal: 0,
          icon: "icon-fangdianguoliang"
        },
        {
          label: "均衡开启数量",
          startVal: 0,
          endVal: 0,
          icon: "icon-junhengxing"
        },
        {
          label: "保护数量",
          startVal: 0,
          endVal: 0,
          icon: "icon-dunpai"
        }
      ],
      timerOne: null,
      timerTwo: null
    };
  },

  watch: {
    myWidth(val) {
      this.myWidth = val;
      // console.log("myWidth")
      // console.log(val)
    },
    myHeight(val) {
      this.myHeight = val;
      // console.log("myHeight")
      // console.log(val)
    },
    TOKEN(val) {
      if (val != null) {
        this.getALLData();
      }
    },
    $route: {
      handler(to) {
        if (to.name === "home") {
          this.getALLData();
        } else {
          window.clearInterval(this.timerOne);
          this.timerOne = null;
          window.clearInterval(this.timerTwo);
          this.timerTwo = null;
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState(["TOKEN"])
  },
  mounted() {
    window.onresize = () => {
      // console.log("宽" + document.body.clientWidth);
      // console.log("高" + document.body.clientHeight);
      // console.log(
      //   "宽/高" + document.body.clientWidth / document.body.clientHeight
      // );
    };
    this.myWidth = document.body.clientWidth;
    this.myHeight = document.body.clientHeight;
    if (this.TOKEN === null) return;
    this.getALLData();
  },

  methods: {
    async getALLData() {
      this.getHomePageInfo();
      // this.getComonInfo();
      // this.getSevenDayOnOfflineInfo();
      // this.cycle();
    },
    async cycle() {
      if (this.timerOne) {
        window.clearInterval(this.timerOne);
        this.timerOne = null;
      }
      this.timerOne = window.setInterval(() => {
        this.getHomePageInfo();
      }, 30 * 1000);
      if (this.timerTwo) {
        window.clearInterval(this.timerTwo);
        this.timerTwo = null;
      }
      this.timerTwo = window.setInterval(() => {
        this.getComonInfo();
        this.getSevenDayOnOfflineInfo();
      }, 60 * 1000);
    },
    mapFlagComplete() {
      
    },
    //获取一般状态统计数据
    async getComonInfo() {
      const ComonInfo = (await this.$API.getComonInfo())["data"]; //一般状态统计
      this.setBatteryAlarmOptions(ComonInfo);
    },
    //统计7日在线离线休眠数目
    async getSevenDayOnOfflineInfo() {
      const SevenDayOnOfflineInfo = (
        await this.$API.getSevenDayOnOfflineInfo()
      )["data"]; //统计7日在线离线休眠数目
      this.initOnlineRate(SevenDayOnOfflineInfo); //统计7日在线离线休眠数目
    },
    //获取其他数据
    async getHomePageInfo() {
      try {
        // const { data } = await this.$API.getHomePageInfo();

        const OnOfflineInfo = (await this.$API.getOnOfflineInfo())[
          "data"
        ]; //获取当前在线、离线、休眠数目

        const BaseAndTodayInfo = (await this.$API.getBaseAndTodayInfo())[
          "data"
        ]; //基本信息与当日统计

        BaseAndTodayInfo.online = OnOfflineInfo.online

        this.setBatteryStatusOptions(BaseAndTodayInfo);
        // this.setCountOptions(BaseAndTodayInfo);
        this.initBatteryType(BaseAndTodayInfo);

        // const CalculatAlarmInfo = (await this.$API.getCalculatAlarmInfo())[
        //   "data"
        // ]; //故障数目统计
        // this.initFault(CalculatAlarmInfo); //故障数目统计

        // const CurveInfo = (await this.$API.getCurveInfo())["data"]; //统计充放电曲线
        // this.initRealStatus(CurveInfo); //统计充放电曲线
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    },
    setBatteryAlarmOptions(data) {
      const {
        totalOverVoltageProtect,
        voltageOverDischargeProtect,
        protectNum,
        balancedOpeningNum
      } = data;
      this.batteryAlarmOptions[0].startVal = this.batteryAlarmOptions[0].endVal =
        totalOverVoltageProtect || 0;
      this.batteryAlarmOptions[1].startVal = this.batteryAlarmOptions[1].endVal =
        voltageOverDischargeProtect || 0;
      this.batteryAlarmOptions[2].startVal = this.batteryAlarmOptions[2].endVal =
        balancedOpeningNum || 0;
      this.batteryAlarmOptions[3].startVal = this.batteryAlarmOptions[3].endVal =
        protectNum || 0;
    },
    setCountOptions(data) {
      const { bmsNoNum, todayIncNum } = data;
      this.countOptions[0].startVal = this.countOptions[0].endVal =
        bmsNoNum || 0;
      this.countOptions[1].startVal = this.countOptions[1].endVal =
        todayIncNum || 0;
    },
    setBatteryStatusOptions(data) {
      const { bmsNoNum, online, todayChargeNum, todayDischargeNum, todayIncNum, todayShortCircuitNum } = data;
      this.batteryStatusOptions[0].startVal = this.batteryStatusOptions[0].endVal =
        bmsNoNum || 0;
      this.batteryStatusOptions[1].startVal = this.batteryStatusOptions[1].endVal =
        online || 0;
      this.batteryStatusOptions[2].startVal = this.batteryStatusOptions[2].endVal =
        todayIncNum || 0;
      this.batteryStatusOptions[3].startVal = this.batteryStatusOptions[3].endVal =
        todayShortCircuitNum || 0;
      this.batteryStatusOptions[4].startVal = this.batteryStatusOptions[4].endVal =
        todayChargeNum || 0;
      this.batteryStatusOptions[5].startVal = this.batteryStatusOptions[5].endVal =
        todayDischargeNum || 0;
      
      return this.batteryStatusOptions;
    },

    initFault(mydata) {
      const options = [
        {
          value: mydata.monomerOverVoltage || 0,
          name: "单体过压",
          color: "rgba(18,195,118,1)"
        },
        {
          value: mydata.monomerLowVoltage || 0,
          name: "单体欠压",
          color: "rgba(18,80,195,1)"
        },
        {
          value: mydata.totalOverVoltage || 0,
          name: "总压过压",
          color: "rgba(211,178,22,1)"
        },
        {
          value: mydata.totalLowVoltage || 0,
          name: "总压欠压",
          color: "rgba(195,43,18,1)"
        },
        {
          value: mydata.chargeHighTemp || 0,
          name: "充电高温",
          color: "rgba(101,18,195,1)"
        },
        {
          value: mydata.chargeLowTemp || 0,
          name: "充电低温",
          color: "rgba(76,203,193,1)"
        },
        {
          value: mydata.sampling || 0,
          name: "采样",
          color: "rgba(2,131,201,1)"
        },
        {
          value: mydata.dischargeHighTemp || 0,
          name: "放电高温",
          color: "rgba(229,133,108,1)"
        },
        {
          value: mydata.dischargeLowTemp || 0,
          name: "放电低温",
          color: "rgba(157,60,189,1)"
        },
        {
          value: mydata.mosHighTemp || 0,
          name: "MOS高温",
          color: "rgba(211,129,22,1)"
        },
        {
          value: mydata.chargeOver || 0,
          name: "充电过流",
          color: "rgba(47,160,32,1)"
        },
        {
          value: mydata.dischargeOver || 0,
          name: "放电过流",
          color: "rgba(83,77,164,1)"
        },
        {
          value: mydata.shortCircuit || 0,
          name: "短路保护",
          color: "rgba(186,32,181,1)"
        },
        {
          value: mydata.electricCore || 0,
          name: "电芯故障",
          color: "rgba(169,213,75,1)"
        }
      ];

      const data = options.map(({ value, name, color }) => ({
        value,
        name: `${name}(${value})`,
        itemStyle: { color },
        icon: "circle"
      }));

      let legendData = [...data];
      // let showNum = this.myHeight >= 650? 10: this.myHeight <= 730?12:8;
      let showNum = this.myHeight >= 880 ? 7 : this.myHeight >= 780 ? 14 : 14;
      legendData.splice(showNum, 0, "\n");
      let center =
        this.myHeight >= 790 && this.myWidth >= 1400
          ? ["70%", "50%"]
          : ["85%", "70%"];
      let radius =
        this.myHeight >= 790 && this.myWidth >= 1400
          ? ["0%", "80%"]
          : ["0%", "50%"];
      this.faultOption = {
        legend: {
          orient: "vertical",
          x: "0",
          y: "center",
          data: legendData,
          textStyle: {
            color: "#fff"
            // fontSize: 8
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}: {d}%"
        },
        series: [
          {
            center: center,
            name: "",
            type: "pie",
            radius: radius,
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            // roseType: "area",
            data
          }
        ]
      };
    },
    initBatteryType(mydata) {
      const options = [
        {
          value: mydata.terNum || 0,
          name: "三元锂电池",
          color: "rgba(8,197,164,1)"
        },
        {
          value: mydata.lihNum || 0,
          name: "磷酸铁锂电池",
          color: "rgba(198,91,33,1)"
        },
        {
          value: mydata.lmNum || 0,
          name: "锰酸锂电池",
          color: "rgba(8,91,33,1)"
        }
      ];

      const data = options.map(({ value, name, color }) => ({
        value,
        name: `${name}(${value})`,
        itemStyle: { color },
        icon: "circle"
      }));
      let myX =
        this.myHeight > 800 ? "50%" : this.myWidth >= 1550 ? "35%" : "25%";
      let myCenter =
        this.myWidth >= 1400 && this.myHeight > 810
          ? ["25%", "50%"]
          : ["15%", "50%"];
      this.batteryTypeOption = {
        legend: {
          orient: "vertical",
          x: myX,
          y: "center",
          data,
          textStyle: {
            color: "#fff"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}: {d}%"
        },
        series: [
          {
            center: myCenter,
            name: "",
            type: "pie",
            radius: ["60%", "80%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            // roseType: "area",
            data
          }
        ]
      };
    },
    initRealStatus(mydata) {
      const chargeData = mydata.chargeDischargeMap;
      const xdata = chargeData ? Object.keys(chargeData[0]) : ["暂无数据"];
      const chargesData = chargeData ? [Object.values(chargeData[0])][0] : [0];
      const dischargesData = chargeData
        ? [Object.values(chargeData[1])][0]
        : [0];
      this.realStausOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: [],
          textStyle: {
            color: "#fff"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: xdata,
            axisLabel: {
              color: "#fff",
              interval: 0
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
              interval: 0
            },
            axisLine: {
              lineStyle: {
                color: "#3c3c44"
              }
            },
            splitLine: {
              lineStyle: {
                color: "#3c3c44"
              }
            }
          },
          {
            type: "value",
            axisLabel: {
              color: "#fff",
              formatter: "{value} ℃",
              interval: 0
            },
            axisLine: {
              lineStyle: {
                color: "#3c3c44"
              }
            },
            splitLine: {
              lineStyle: {
                color: "#3c3c44"
              }
            }
          }
        ],
        series: [
          {
            name: "充电数量",
            type: "bar",
            data: chargesData,
            itemStyle: {
              normal: { color: "rgba(8,197,164,1)" }
            },
            barGap: "0%",
            barWidth: 10
          },
          {
            name: "放电数量",
            type: "bar",
            data: dischargesData,
            itemStyle: {
              normal: { color: "rgba(198,91,33,1)" }
            },
            barWidth: 10
          }
          // {
          //   name: "Charging temperature",
          //   type: "line",
          //   yAxisIndex: 1,
          //   data: [23, 24, 27, 21, 43, 36],
          //   itemStyle: {
          //     normal: { color: "rgba(35,103,226,1)" }
          //   }
          // },
          // {
          //   name: "Discharge temperature",
          //   type: "line",
          //   yAxisIndex: 1,
          //   data: [33, 34, 40, 34, 53, 53],
          //   itemStyle: {
          //     normal: { color: "rgba(107,35,226,1)" }
          //   }
          // }
        ]
      };
    },
    initOnlineRate(mydata) {
      const chargeData = mydata.sevenDayMap;
      const xdata = chargeData ? Object.keys(chargeData[0]) : ["暂无数据"];
      // const chargesData = [Object.values(chargeData[0])];
      const sleepData = chargeData ? [Object.values(chargeData[0])][0] : [0];
      const onlineData = chargeData ? [Object.values(chargeData[1])][0] : [0];
      const offlineData = chargeData ? [Object.values(chargeData[2])][0] : [0];
      this.onlineRateOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: [],
          textStyle: {
            color: "#fff"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: xdata,
            axisLabel: {
              color: "#fff"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
              interval: 0
            },
            axisLine: {
              lineStyle: {
                color: "#3c3c44"
              }
            },
            splitLine: {
              lineStyle: {
                color: "#3c3c44"
              }
            }
          }
        ],
        series: [
          {
            name: "在线设备",
            type: "bar",
            data: onlineData,
            itemStyle: {
              normal: { color: "rgba(24,98,220,1)" }
            },
            barWidth: 10,
            barGap: "0%"
          },
          {
            name: "休眠",
            type: "bar",
            data: sleepData,
            itemStyle: {
              normal: { color: "rgba(198,91,33,1)" }
            },
            barWidth: 10,
            barGap: "0%"
          },
          {
            name: "离线",
            type: "bar",
            data: offlineData,
            itemStyle: {
              normal: { color: "rgba(145,145,145,1)" }
            },
            barWidth: 10
          }
        ]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
$gap: 16px; //容器间隙
$bg: rgba(26,30,37,0.7);

.home {
  width: 100%;
  height: 100%;
  overflow: hidden;

  ::v-deep .Card {
    width: 604px;
    background: $bg;

    .Chart {
      height: 100%;
    }
  }

  &__left {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 $gap;
    box-sizing: border-box;
    height: 98%;
    display: flex;
    flex-direction: column;

    ::v-deep .Card {
      margin-top: $gap;
    }
  }

  &__underside {
    width: 100%;
    height: 30%;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: $gap;
    display: flex;
    box-sizing: border-box;
  }

  &__underside-item {
    border-left: 1px solid rgba(60, 60, 68, 1);
    background: $bg;

    &:nth-of-type(3) {
      margin-right: $gap;
    }
  }
}
</style>
